var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQuickResponse = function SvgQuickResponse(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#quick-response_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 1.015,
    d: "M30.047 17.299h8.456m-8.456 4.059h5.75m-5.75 4.059h3.382"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m26.151 27.376-.231.206c-.391.347-.901.53-1.424.511l-3.752-.139-.133 4.006a2.7 2.7 0 0 1-.791 1.823l-.429.429-2.198-6.785H11.41c-1.06-7.17-8.566-16.15-8.425-16.723.1-.403 1.114-.872 1.873-1.199a3.9 3.9 0 0 1 1.549-.323h19.578c.468 0 .847.378.847.845V25.86a2.03 2.03 0 0 1-.682 1.517Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#quick-response_svg__b)",
    fillOpacity: 0.4,
    d: "m26.151 27.376-.231.206c-.391.347-.901.53-1.424.511l-3.752-.139-.133 4.006a2.7 2.7 0 0 1-.791 1.823l-.429.429-2.198-6.785H11.41c-1.06-7.17-8.566-16.15-8.425-16.723.1-.403 1.114-.872 1.873-1.199a3.9 3.9 0 0 1 1.549-.323h19.578c.468 0 .847.378.847.845V25.86a2.03 2.03 0 0 1-.682 1.517Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.507,
    d: "M3.456 10.788h21.05a.89.89 0 0 1 .892.89v15.3a.89.89 0 0 1-.891.891H19.9a.59.59 0 0 0-.591.592v5.398c0 .082-.105.116-.154.05l-4.034-5.471a1.4 1.4 0 0 0-1.125-.569H3.456a.89.89 0 0 1-.89-.89V11.678a.89.89 0 0 1 .89-.89Z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.382,
    height: 3.382,
    x: 6.453,
    y: 17.638,
    fill: "currentColor",
    rx: 1.691
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.382,
    height: 3.382,
    x: 12.203,
    y: 17.638,
    fill: "currentColor",
    rx: 1.691
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.382,
    height: 3.382,
    x: 17.953,
    y: 17.638,
    fill: "currentColor",
    rx: 1.691
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "quick-response_svg__b",
    x1: 30.046,
    x2: -15.279,
    y1: 15.947,
    y2: -1.642,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "quick-response_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h40v40H0z"
  })))));
};
export default SvgQuickResponse;